import { render, staticRenderFns } from "./myPrescribeDetailModal.vue?vue&type=template&id=b41fc5d0"
import script from "./myPrescribeDetailModal.vue?vue&type=script&lang=js"
export * from "./myPrescribeDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports